import React, { useEffect } from 'react';
import ReactFlow, {
  Background,
  BackgroundVariant,
  Controls,
  MiniMap,
  ReactFlowProvider,
  useReactFlow,
} from 'reactflow';

import 'reactflow/dist/style.css';

import { DiagramGraph } from './layout';
import { DiagramNodeData, diagramNodeTypes } from './nodes';

interface ForgeDiagramProps {
  graph: DiagramGraph;
}

const DiagramInner: React.FC<ForgeDiagramProps> = ({ graph }) => {
  const { fitView } = useReactFlow();

  // Refit the viewport when the visible structure changes (collapse/expand).
  useEffect(() => {
    const t = window.setTimeout(() => fitView({ padding: 0.2, duration: 300 }), 0);
    return () => window.clearTimeout(t);
  }, [graph, fitView]);

  return (
    <ReactFlow
      nodes={graph.nodes}
      edges={graph.edges}
      nodeTypes={diagramNodeTypes}
      fitView
      fitViewOptions={{ padding: 0.2 }}
      proOptions={{ hideAttribution: true }}
      nodesDraggable={false}
      nodesConnectable={false}
      nodesFocusable={false}
      edgesFocusable={false}
      elementsSelectable={false}
      selectNodesOnDrag={false}
      minZoom={0.2}
      maxZoom={1.5}
    >
      <Background variant={BackgroundVariant.Dots} gap={16} size={1} />
      <Controls showInteractive={false} />
      <MiniMap
        pannable
        zoomable
        nodeColor={(n) => {
          switch ((n.data as DiagramNodeData)?.kind) {
            case 'user':
              return 'hsl(var(--muted-foreground))';
            case 'org':
              return '#a855f7';
            case 'client':
              return '#0ea5e9';
            case 'forge':
              return '#10b981';
            case 'app':
              return '#f59e0b';
            default:
              return '#94a3b8';
          }
        }}
      />
    </ReactFlow>
  );
};

export const ForgeDiagram: React.FC<ForgeDiagramProps> = ({ graph }) => (
  <ReactFlowProvider>
    <DiagramInner graph={graph} />
  </ReactFlowProvider>
);

export default ForgeDiagram;
